module.exports = __webpack_public_path__ + "media/feature-icons/Submissions_Editing-a0754191.svg";